import React from 'react';

const Pay = () => {
    return (
        <div className="container my-5 py-5">
            <h2 className="container my-5 py-5">Payment System Coming Soon</h2>
        </div>
    );
};

export default Pay;